class KeyCompounds {
  constructor() {
    this.section = document.querySelector('.key-compounds');
    if (!this.section) return;

    this.dropdownToggles = this.section.querySelectorAll('.key-compounds__item-toggle');
    this.init();
  }

  init() {
    this.initDropdowns();
    this.initVideoControls();
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Inicializar estado por defecto
    this.initDefaultState();
  }

  initDefaultState() {
    const isMobile = window.innerWidth <= 990;
    if (isMobile) {
      this.openFirstItem();
    }
  }

  initDropdowns() {
    this.dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', this.handleDropdownToggle.bind(this));
      toggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleDropdownToggle(e);
        }
      });
    });
  }

  handleDropdownToggle(event) {
    const toggle = event.currentTarget;
    const content = toggle.nextElementSibling;
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    this.closeAllDropdowns();

    if (!isExpanded) {
      toggle.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      content.classList.add('expanded');
    }
  }

  closeAllDropdowns() {
    this.dropdownToggles.forEach(toggle => {
      const content = toggle.nextElementSibling;
      toggle.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.classList.remove('expanded');
    });
  }

  initVideoControls() {
    const wrappers = document.querySelectorAll('.key-compounds__video');
    wrappers.forEach((wrap) => {
      const video = /** @type {HTMLVideoElement|null} */(wrap.querySelector('.key-compounds__video-el'));
      const playBtn = /** @type {HTMLElement|null} */(wrap.querySelector('.key-compounds__video-play'));
      if (!video || !playBtn) return;

      const shouldAutoplay = video.hasAttribute('data-autoplay');

      const hidePlayButton = () => {
        playBtn.style.display = 'none';
      };

      const showPlayButton = () => {
        playBtn.style.display = '';
      };

      const attachPlayHandler = () => {
        playBtn.addEventListener('click', handlePlayClick);
      };

      const detachPlayHandler = () => {
        playBtn.removeEventListener('click', handlePlayClick);
      };

      const handlePlayClick = () => {
        startPlayback();
      };

      const startPlayback = () => {
        detachPlayHandler();
        hidePlayButton();
        try {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch(() => {
              video.controls = true;
              showPlayButton();
              attachPlayHandler();
            });
          }
        } catch (e) {
          video.controls = true;
          showPlayButton();
          attachPlayHandler();
        }
      };

      /**
       * @param {boolean} shouldPlay
       */
      const resetToPausedState = (shouldPlay) => {
        video.controls = false;
        if (!shouldPlay) {
          video.pause();
        }
        if (shouldPlay) {
          hidePlayButton();
        } else {
          showPlayButton();
          attachPlayHandler();
        }
      };

      video.addEventListener('play', () => {
        video.controls = true;
        hidePlayButton();
      });

      video.addEventListener('pause', () => {
        if (video.ended) return;
        if (video.muted) {
          video.controls = false;
          showPlayButton();
          attachPlayHandler();
        }
      });

      video.addEventListener('ended', () => {
        video.controls = false;
        showPlayButton();
        attachPlayHandler();
      });

      resetToPausedState(shouldAutoplay);

      if (shouldAutoplay) {
        startPlayback();
      }
    });
  }

  handleResize() {
    const isMobile = window.innerWidth <= 990;
    if (!isMobile) {
      this.closeAllDropdowns();
    } else {
      // En móvil, abrir el primer item por defecto
      this.openFirstItem();
    }
  }

  openFirstItem() {
    if (this.dropdownToggles.length > 0) {
      const firstToggle = this.dropdownToggles[0];
      const firstContent = firstToggle.nextElementSibling;
      
      // Cerrar todos primero
      this.closeAllDropdowns();
      
      // Abrir el primero
      firstToggle.setAttribute('aria-expanded', 'true');
      firstContent.setAttribute('aria-hidden', 'false');
      firstContent.classList.add('expanded');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new KeyCompounds();
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId.includes('key-compounds')) {
    new KeyCompounds();
  }
});
